import { ColumnType } from "antd/lib/table";
import Status from "./Status";

const columns: ColumnType<any>[] = [
  {
    title: "CÓDIGO",
    dataIndex: "codigo",
    align: "center",
    render: (value: string) => <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>,
  },
  {
    title: "CULTURA",
    dataIndex: "nome",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
  {
    title: "VISÍVEL NOS FILTROS",
    dataIndex: "exibir",
    align: "center",
    render: (value: boolean, record: any) => <Status active={value} ocupacaoId={record.ocupacaoId} />,
  },
];

export default columns;
